/**
 * Benefits section: text slides in from the left, the checklist from the
 * right — same converging-halves treatment as the About section.
 */
import { revealOnScroll } from '@theme/premium-motion';

revealOnScroll('.flv-product-benefits__left', { x: -32, y: 0, scale: 1, duration: 0.8 });
revealOnScroll('.flv-product-benefits__list', { x: 32, y: 0, scale: 1, duration: 0.8, delay: 0.1 });
